@if (url) {
  <app-embed-display [url]="url"></app-embed-display>
}
